module.exports = __webpack_public_path__ + "static/media/praca-ciagla-on.1fed0800.svg";